export default "__VITE_ASSET__D2Bgzzc6__"